module.exports = __webpack_public_path__ + "img/ZAdyn4C_011-032_ZD4C01M0-front.69a99a71.jpg";